export default {
  // Header Navigation
  'nav.features': 'Features',
  'nav.applications': 'Application Areas',
  'nav.service': 'Service',
  'nav.fairs': 'Fairs',
  'nav.layoutPlan': 'Layout Plan',
  'nav.cuttingThickness': 'Cutting Thickness',
  'nav.getQuote': 'Get Quote',
  'nav.eCatalog': 'E-Catalog',
  'nav.onlineOrder': 'Online Order',
  
  // Hero Section
  'hero.title': 'AJAN LASER Fiber Laser Cutting Machines',
  'hero.subtitle': 'AJAN LASER, a reliable and innovative manufacturer of fiber laser cutting machines.',
  'hero.closedCabin': 'Fully Enclosed Fiber Laser',
  'hero.mobileCabin': 'Enclosed Gantry Fiber Laser',
  'hero.layoutPlan': 'Layout Plan',
  'hero.cuttingThickness': 'Cutting Thickness',
  
  // Specifications
  'specs.title': 'General Specifications',
  'specs.closedCabin': 'Fully Enclosed General Specifications',
  'specs.mobileCabin': 'Enclosed Gantry General Specifications',
  'specs.laserPower': 'Laser Power',
  'specs.zAxisHeight': 'Z-Axis Movement Height',
  'specs.xyPositionAccuracy': 'X/Y Axes Position Accuracy',
  'specs.xyRepeatAccuracy': 'X/Y Axes Repeat Accuracy',
  'specs.xyMaxSpeed': 'X/Y Maximum Speed',
  'specs.xyMaxSpeedValue': '88 m/min',
  'specs.xyMaxSpeedIdle': 'X/Y Maximum Speed Idle',
  'specs.xyMaxSpeedIdleValue': '30 m/min',
  'specs.xyMaxAcceleration': 'X/Y Maximum Acceleration',
  'specs.laserSource': 'Laser Source',
  'specs.laserHead': 'Laser Cutting Head',
  'specs.body': 'Body',
  'specs.bodyValue': 'Ajan Laser',
  'specs.xyRail': 'X/Y Precision Axis Rail',
  'specs.xyRack': 'X/Y Precision Axis Rack',
  'specs.xyRackValue': 'Taiwan',
  'specs.servoMotors': 'X/Y/Z Servo Motors and Drivers',
  'specs.reducer': 'Reducer',
  'specs.electricalComponents': 'Electrical Components',
  'specs.lubricationSystem': 'Automatic Lubrication System',
  'specs.lubricationSystemValue': 'Chinese',
  'specs.chiller': 'Chiller (Air Chiller)',
  'specs.pneumaticComponents': 'Pneumatic Components',
  'specs.cncControl': 'CNC Control System',
  
  // Advantages
  'advantages.title': 'Key Advantages',
  'advantages.fullSafety': 'Full Safety',
  'advantages.fullSafetyDesc': 'Maximum operator safety with closed cabin design',
  'advantages.compactDesign': 'Compact Design',
  'advantages.compactDesignDesc': 'Efficient layout with small space requirement',
  'advantages.excellentCutting': 'Excellent Cutting Quality',
  'advantages.excellentCuttingDesc': 'Smooth edge surfaces and precise cutting performance',
  'advantages.energyEfficiency': 'Energy Efficiency',
  'advantages.energyEfficiencyDesc': 'Economical operation with low energy consumption',
  'advantages.wideWorkArea': 'Wide Work Area',
  'advantages.wideWorkAreaDesc': 'Ideal wide work area for processing large sheets',
  'advantages.mobileCabinSystem': 'Mobile Cabin System',
  'advantages.mobileCabinSystemDesc': 'Flexible and efficient production with mobile cabin technology',
  'advantages.highCapacity': 'High Production Capacity',
  'advantages.highCapacityDesc': 'High capacity optimized for serial production',
  'advantages.easyMaintenance': 'Easy Maintenance',
  'advantages.easyMaintenanceDesc': 'Easy access and fast maintenance thanks to modular structure',
  
  // Features Section
  'features.title': 'Features of AJAN LASER Fiber Laser Cutting Machine',
  'features.subtitle': 'High technology and quality in every detail',
  'features.bodyStrength': 'Superior Body Durability',
  'features.bodyStrengthDesc': 'After annealing, rough machining and then vibration stress relief can completely eliminate the internal stress of welding. With 12-meter portal milling, the machine has good rigidity and high precision and can be used for a long time without deformation.',
  'features.beamStructure': 'Light and Strong Beam Structure',
  'features.beamStructureDesc': 'The beam adopts extruded aluminum welded integrated entry; has good rigidity, lightness, fast dynamic response and stable operation and can be used for a long time without deformation.',
  'features.servoSystems': 'High Performance Servo Systems',
  'features.servoSystemsDesc': 'All X/Y/Z axes use DELTA servo motors with high precision, high speed, large torque with stable and durable performance characteristics. High performance cutting head drilling thick plate only needs a few seconds.',
  'features.ventilationSystem': 'Advanced Ventilation System',
  'features.ventilationSystemDesc': 'The ventilation system uses a closed space structure that ensures the continuity of the smoke evacuation effect. Thus, the acceleration of the machine bed becomes more stable and faster.',
  'features.modularDesign': 'Modular and Maintenance-Friendly Design',
  'features.modularDesignDesc': 'The industry\'s first simple integrated design has a detachable structure suitable for maintenance and revisions that may be required in the future.',
  'features.domesticProduction': 'Domestic Production',
  'features.domesticProductionDesc': 'Reliable and accessible with domestic production power',
  'features.serviceNetwork': 'Wide Service Network',
  'features.serviceNetworkDesc': 'Fast and effective service throughout Turkey',
  'features.easyToUse': 'Easy to Use',
  'features.easyToUseDesc': 'User-friendly interface and simple operation',
  'features.speedDesc': 'High cutting speed and excellent performance',
  
  // Trust Section
  'trust.badge': 'Since 1973...',
  'trust.title': 'Turkey\'s Pioneer with 50 Years of Experience and 15 Years of R&D',
  'trust.description': 'Our company, which has been in the sector since 1973, is Turkey\'s pioneer in CNC Fiber Laser Cutting technology with 15 years of meticulous R&D work. We continue our global success with 6000+ machines in over 70 countries.',
  'trust.experience': 'Years of Experience',
  'trust.machines': 'Installed Machines',
  'trust.countries': 'Countries',
  'trust.laserRD': 'Years Laser R&D',
  'trust.leadership': 'Half Century Leadership',
  'trust.leadershipDesc': 'Our company, which has been in the sector since 1973, has developed CNC Fiber Laser Cutting Machines by reaching the peak of 15 years of meticulous R&D work.',
  'trust.deepRoots': 'Deep Roots and Trust',
  'trust.deepRootsDesc': 'With our sectoral experience of over 50 years and deep roots in cutting technology, we offer solutions above quality standards in every project.',
  'trust.rdPeak': '15 Years of R&D Peak',
  'trust.rdPeakDesc': 'By reaching the peak of our meticulous R&D work that lasted for fifteen years, we have developed CNC Fiber Laser Cutting Machines that will revolutionize cutting technology.',
  
  // Certifications
  'cert.title': 'Quality and Safety Standards',
  'cert.description': 'AJAN LASER machines are manufactured in full compliance with international quality and safety standards. Our priority is to offer our customers the highest quality and safe products.',
  'cert.ce': 'CE Certificate',
  'cert.ceDesc': 'European Conformity',
  'cert.iso12100': 'TS EN ISO 12100',
  'cert.iso12100Desc': 'Machine Safety',
  'cert.iso60204': 'TS EN 60204-1',
  'cert.iso60204Desc': 'Electrical Safety',
  'cert.iso60974': 'TS EN IEC 60974-1',
  'cert.iso60974Desc': 'Power Source Safety',
  'cert.emcLvd': 'EMC and LVD Tests',
  
  // Application Areas
  'app.title': 'Application Areas',
  'app.subtitle': 'Perform high-precision cutting operations on various metal materials with AJAN LASER fiber laser cutting machines',
  'app.aluminum': 'Aluminum',
  'app.aluminumDesc': 'Precision Cutting',
  'app.carbonSteel': 'Carbon Steel',
  'app.carbonSteelDesc': 'Strong Cutting',
  'app.brass': 'Brass',
  'app.brassDesc': 'Quality Processing',
  'app.stainlessSteel': 'Stainless Steel',
  'app.stainlessSteelDesc': 'Smooth Surface',
  'app.otherMetals': 'Other Metals',
  'app.otherMetalsDesc': 'Versatile',
  'app.materialsTitle': 'Applicable Materials',
  'app.materialsDesc1': 'AJAN LASER fiber laser cutting machines offer excellent cutting performance on a wide range of metals. Our machines provide high precision and quality in cutting stainless steel, carbon steel, galvanized sheet, electrolyzed plate, aluminum plate, copper plate, brass plate, bronze plate and other metal materials.',
  'app.materialsDesc2': 'Our machines, which show superior performance especially in processing thin metal sheets, are widely used in automotive, aviation, electronics, furniture, decoration, advertising and metal processing sectors.',
  'app.materialsDesc3': 'Thanks to advanced fiber laser technology, you can cut different thicknesses and types of metal materials quickly, economically and precisely, and easily process complex geometric shapes.',
  
  // After Sales Service
  'service.title': 'After Sales Service',
  'service.subtitle': 'We are with you with our strong technical support team and service network throughout Turkey',
  'service.warranty': '2 Year Warranty',
  'service.warrantyDesc': 'The warranty period of the cutting machine is 2 years against production and manufacturing defects. Spare parts replacements due to failure during the warranty period will be provided free of charge.',
  'service.exclusions': 'Warranty Exclusions',
  'service.exclusionsDesc': 'Dust contamination inside the cutting head, optical cables, QBH output heads, laser due to condensation or internal icing, general consumables (optical lenses, cutting nozzles, etc.) and accidents are not covered by warranty.',
  'service.technicalSupport': 'Strong Technical Support',
  'service.fastService': 'Fast Service',
  'service.spareParts': 'Spare Parts',
  'service.expertTeam': 'Expert Team',
  
  // Why Choose Us
  'why.title': 'Why AJAN LASER?',
  'why.subtitle': 'Our values that make a difference in the sector and our customer-oriented approach',
  'why.reliableTech': 'Reliable Technology',
  'why.reliableTechDesc': 'World-standard components and proven performance',
  'why.affordableCost': 'Affordable Cost',
  'why.affordableCostDesc': 'Best return on investment with high quality and competitive pricing',
  'why.continuousInnovation': 'Continuous Innovation',
  'why.continuousInnovationDesc': 'Continuously developing and renewing product range with R&D studies',
  'why.customerFocused': 'Customer Focused Approach',
  'why.customerFocusedDesc': 'Solutions tailored to your needs and full after-sales support',
  
  // CTA Section
  'cta.title': 'Ready to Transform Your Production Process?',
  'cta.subtitle': 'Let\'s determine the most suitable fiber laser solution for your needs together.',
  'cta.callNow': 'Call Now: +90 444 25 26',
  'cta.viewCatalogs': 'View Catalogs',
  
  // Contact Form
  'form.title': 'Get a Quote',
  'form.subtitle': 'Our technical team will analyze your request and contact you as soon as possible.',
  'form.companyName': 'Company Name',
  'form.companyNamePlaceholder': 'Enter your company name',
  'form.fullName': 'Full Name',
  'form.fullNamePlaceholder': 'Your name and surname',
  'form.email': 'Email Address',
  'form.emailPlaceholder': 'example@email.com',
  'form.phone': 'Phone Number',
  'form.phonePlaceholder': '0555 555 55 55',
  'form.address': 'Address Information',
  'form.addressPlaceholder': 'Enter your address information',
  'form.message': 'Your Message',
  'form.messagePlaceholder': 'Provide detailed information about your quote request (maximum 500 characters)',
  'form.characters': 'characters',
  'form.submit': 'Send Quote Request',
  'form.submitting': 'Sending...',
  'form.success': 'Your form has been successfully submitted! We will get back to you as soon as possible.',
  'form.error': 'An error occurred. Please try again.',
  'form.required': '*',
  
  // Footer
  'footer.description': 'High-performance fiber laser systems engineered for modern manufacturing.',
  'footer.quickLinks': 'Quick Links',
  'footer.home': 'Home',
  'footer.catalog': 'Catalog',
  'footer.fairs': 'Fairs',
  'footer.cuttingThickness': 'Cutting Thickness',
  'footer.contact': 'Contact',
  'footer.factory': 'Factory:',
  'footer.customerService': 'Customer Service:',
  'footer.certifications': 'Certifications',
  'footer.ceCertificate': 'CE Certificate',
  'footer.iso9001': 'ISO 9001',
  'footer.emcLvdTests': 'EMC and LVD Tests',
  'footer.tsEnIso12100': 'TS EN ISO 12100',
  'footer.rights': '© 2025 AJAN LAZER. All rights reserved.',
  'footer.websiteBuilder': 'Website Builder',
  
  // Catalog Page
  'catalog.title': 'Product Catalogs',
  'catalog.subtitle': 'Discover the most suitable model for your needs by reviewing AJAN FIBER laser cutting machine catalogs',
  'catalog.closedCabinTitle': 'Fully Enclosed Fiber Laser Catalog',
  'catalog.closedCabinDesc': 'Fully enclosed fiber laser cutting machines with compact design and high safety standards. Ideal solution for small and medium-sized part production.',
  'catalog.mobileCabinTitle': 'Enclosed Gantry Fiber Laser Catalog',
  'catalog.mobileCabinDesc': 'Enclosed gantry fiber laser cutting machines with large sheet processing capacity. Professional solution for businesses requiring high production volume.',
  'catalog.features': 'Key Features',
  'catalog.feature1': 'Fully closed safe working area',
  'catalog.feature2': 'Compact design',
  'catalog.feature3': 'Easy material loading',
  'catalog.feature4': 'Energy efficiency',
  'catalog.feature5': 'Wide work area',
  'catalog.feature6': 'Mobile cabin system',
  'catalog.feature7': 'Large sheet processing',
  'catalog.feature8': 'High production capacity',
  'catalog.downloadPdf': 'Download PDF Catalog',
  'catalog.ctaTitle': 'Need Detailed Information and Price Quote?',
  'catalog.ctaSubtitle': 'Contact us now to get detailed information about our products and receive a special price quote.',
  'catalog.ctaButton': '+90 444 25 26',
  'catalog.closedCabinPdfUrl': 'https://files.ajanlaser.com/wp-content/uploads/2025/03/AJAN-FIBER-LASER-CUTTING-MACHINES-CATALOG-2024-EN-Comp.pdf',
  'catalog.mobileCabinPdfUrl': 'https://files.ajanlaser.com/wp-content/uploads/2025/11/cutting-machine.pdf',
  
  // Fairs Page
  'fairs.title': 'Trade Fair and Event Calendar',
  'fairs.subtitle': 'Visit AJAN LASER at national and international fairs, examine our products closely',
  'fairs.upcoming': 'Upcoming Fairs',
  'fairs.upcomingDesc': 'Future events where you can visit us',
  'fairs.past': 'Past Fairs',
  'fairs.pastDesc': 'Previous events we participated in',
  'fairs.details': 'DETAILS',
  'fairs.noUpcoming': 'There are no upcoming fairs.',
  'fairs.noPast': 'There are no past fair records.',
  'fairs.ctaTitle': 'See You at the Fairs',
  'fairs.ctaSubtitle': 'Visit our booth, examine our products closely and meet our expert team',
  'fairs.callForAppointment': 'Call for Appointment',
  
  // Cutting Thickness Page
  'thickness.title': 'Cutting Thickness',
  'thickness.subtitle': 'Maximum Cutting Capacities by Laser Power',
  'thickness.chartTitle': 'Cutting Capacities Table',
  'thickness.laserPower': 'Laser Power',
  'thickness.iron': 'Iron',
  'thickness.stainlessSteel': 'Stainless Steel',
  'thickness.aluminum': 'Aluminum',
  'thickness.brass': 'Brass',
  'thickness.materialTypes': 'Material Types',
  'thickness.importantNotes': 'Important Notes',
  'thickness.note1': '• Cutting thicknesses are maximum values obtained under optimal working conditions.',
  'thickness.note2': '• Actual cutting performance may vary depending on material quality and working conditions.',
  'thickness.note3': '• Please contact us for detailed technical information and special applications.',
  'thickness.techAdvantages': 'Technical Advantages',
  'thickness.highPower': 'High Power Options',
  'thickness.highPowerDesc': 'Solution suitable for every need with wide power range from 3KW to 20KW',
  'thickness.versatileMaterial': 'Versatile Material Support',
  'thickness.versatileMaterialDesc': 'Cutting on various materials such as iron, stainless steel, aluminum and brass',
  'thickness.maxEfficiency': 'Maximum Efficiency',
  'thickness.maxEfficiencyDesc': 'Production efficiency with high cutting speed and excellent edge quality',
  'thickness.ctaTitle': 'Determine the Right Power for Your Needs',
  'thickness.ctaSubtitle': 'Talk to our experts to find out which laser power is ideal for your business',
  'thickness.callForAppointment2': 'Call for Appointment: 444 25 26',
  
  // Layout Plan Page
  'layoutPlan.title': 'Layout Plans',
  'layoutPlan.subtitle': 'View and download technical layout plans for our fiber laser cutting machines',
  'layoutPlan.closedCabin': 'Fully Enclosed Fiber Laser',
  'layoutPlan.closedCabinDesc': 'Compact design and fully enclosed fiber laser cutting machines providing full safety',
  'layoutPlan.movingCabin': 'Enclosed Gantry Fiber Laser',
  'layoutPlan.movingCabinDesc': 'Enclosed gantry fiber laser cutting machines offering wide work area and high capacity',
  'layoutPlan.downloadPdf': 'Download PDF',
  'layoutPlan.pipeCutting': '6m Pipe Cutting',
  'layout.title': 'Layout Plan',
  'layout.subtitle': 'Detailed technical drawings and plans for optimal placement of your fiber laser cutting machines in the factory or workshop',
  'layout.closedLaser': 'Fully Enclosed',
  'layout.mobileCabin': 'Enclosed Gantry',
  'layout.uploadPng': 'Upload PNG File',
  'layout.loading': 'Loading...',
  
  // Closed Cabin Page
  'closedCabin.title': 'Fully Enclosed Fiber Laser',
  'closedCabin.subtitle': 'Fully enclosed fiber laser cutting machines with compact design and high safety standards',
  'closedCabin.ctaTitle': 'Get Detailed Information About Fully Enclosed Fiber Laser',
  'closedCabin.ctaSubtitle': 'Our technical team is ready to offer you the most suitable solution',
  'closedCabin.callNow': 'Call Now: 444 23 26',
  'closedCabin.downloadCatalog': 'Download Catalog',
  
  // Mobile Cabin Page
  'mobileCabin.title': 'Enclosed Gantry Fiber Laser',
  'mobileCabin.subtitle': 'Professional solution with large sheet processing capacity',
  'mobileCabin.overview': 'High Capacity, Maximum Efficiency',
  'mobileCabin.overviewDesc1': 'AJAN LAZER Enclosed Gantry Fiber Laser Cutting Machines offer professional solutions for businesses requiring high production volume with large sheet processing capacity. Thanks to the enclosed gantry system, you can make flexible and efficient production in a wide work area.',
  'mobileCabin.overviewDesc2': 'Our machines equipped with world-standard components and advanced technology provide maximum performance and precision in serial production.',
  'mobileCabin.advantages': 'Advantages',
  'mobileCabin.advantagesSubtitle': 'Advantages you will gain with Mobile Cabin Fiber Laser',
  'mobileCabin.ctaTitle': 'Detailed Information and Price Quote',
  'mobileCabin.ctaSubtitle': 'Contact us for more information about Enclosed Gantry Fiber Laser',
  'mobileCabin.totalSpecs': 'Total Specifications',
  'mobileCabin.specsListed': 'Technical Specifications Successfully Listed',
  
  specs: {
    laserPower: 'Laser Power',
    zAxisHeight: 'Z-Axis Height',
    xyPositionAccuracy: 'X/Y POSITIONING ACCURACY',
    xyRepeatAccuracy: 'X/Y Repeat Accuracy',
    xyMaxSpeed: 'X/Y Max Speed',
    xyMaxSpeedValue: 'Up to 150 m/min',
    xyMaxAcceleration: 'X/Y Max Acceleration',
    laserSource: 'Laser Source',
    laserHead: 'Laser Head',
    body: 'Body',
    bodyValue: 'Welded Steel Construction',
    xyRail: 'X/Y Rail',
    xyRack: 'X/Y Rack',
    xyRackValue: 'Helical Gear Rack',
    servoMotors: 'Servo Motors',
    reducer: 'Reducer',
    electricalComponents: 'Electrical Components',
    lubricationSystem: 'Lubrication System',
    lubricationSystemValue: 'Automatic Lubrication',
    chiller: 'Chiller',
    pneumaticComponents: 'Pneumatic Components',
    cncControl: 'CNC Control',
    xyMaxSpeedIdle: 'X/Y Max Speed (Idle)',
    xyMaxSpeedIdleValue: 'Up to 100 m/min',
    cuttingCapacity: 'Cutting Capacity',
    cuttingLength: 'Cutting Length',
    cabinStructure: 'CABIN STRUCTURE',
    rotaryAxisStructure: 'ROTARY AXIS STRUCTURE',
    standardWorkingAreaOptions: 'STANDARD WORKING AREA OPTIONS',
    standardTubeProfileCuttingCapacities: 'STANDARD TUBE AND PROFILE CUTTING CAPACITIES',
  },
  
  productDetails: {
    // Kapalı Kabin
    kapaliKabin: {
      cabinStructure: 'CABIN STRUCTURE',
    },
  },
};
